import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import * as dateHelper from '../../../lib/dates';
import styles from './timeplan.css';
import copyTimeplanUnitsFromDateToDates from './copyTimeplanUnitsFromDateToDates';
import { useTranslation } from 'react-i18next';



function Item({ item, date, selectedDates, onChangeTimeplanUnits }) {
  return (
    <li
      role="button"
      tabIndex="0"
      onClick={() => (
        onChangeTimeplanUnits(
          copyTimeplanUnitsFromDateToDates,
          dateHelper.getDate(date),
          item.dateFilter(date, selectedDates.toJS()).map(_date => dateHelper.getDate(_date)),
        )
      )}
      key={item.label}
    >
      <a>{item.label}</a>
    </li>
  );
}

export default function TimeplanDayCopy({ date, disabled, selectedDates, onChangeTimeplanUnits }) {

  const { t } = useTranslation();

  const Options = [
    {
      label: t('Samma dag övriga veckor'),
      dateFilter: dateHelper.selectSameDayOtherWeeks,
    },
    {
      label: t('Samtliga vardagar denna vecka'),
      dateFilter: dateHelper.selectWeekdaysSameWeek,
    },
    {
      label: t('Samtliga dagar denna vecka'),
      dateFilter: dateHelper.selectDaysSameWeek,
    },
    {
      label: t('Samtliga vardagar'),
      dateFilter: dateHelper.selectWeekdays,
    },
    {
      label: t('Samtliga helgdagar'),
      dateFilter: dateHelper.selectWeekendDays,
    },
    {
      label: t('Samtliga dagar'),
      dateFilter: dateHelper.selectAllDays,
    },
  ];
  if (disabled) {
    return null;
  }
  const weekDay = moment(date).isoWeekday();

  return (
    <div className="btn-group pull-right">
      <button
        className={`btn btn-default btn-xs dropdown-toggle ${styles.copyButton}`}
        data-toggle="dropdown"
        aria-expanded="false"
      >
        <i className="fa fa-clone" />
        <span className="caret" />
      </button>

      <ul className={`dropdown-menu ${weekDay <= 5 ? styles.dropdownResponsive : ''}`}>
        <li className={styles.copyTimesHeader}><b>{t("Kopiera tider till")}</b></li>
        {Options.map(item => (
          <Item
            key={item.label}
            item={item}
            date={dateHelper.getDate(date)}
            selectedDates={selectedDates}
            onChangeTimeplanUnits={onChangeTimeplanUnits}
          />
        ))}
      </ul>
    </div>
  );
}

TimeplanDayCopy.propTypes = {
  date: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  selectedDates: PropTypes.object.isRequired,
};
